import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface SelectCollaborationStatusProps {
  value: string;
  onChange: (value: string) => void;
}

const SelectCollaborationStatus = ({
  value,
  onChange
}: SelectCollaborationStatusProps) => (
  <FormControl size="small" sx={{ minWidth: 150 }}>
    <InputLabel>Author Role</InputLabel>
    <Select
      id="collaboration-status"
      name="collaboration-status"
      value={value}
      label="Author Role"
      onChange={(event) => onChange(event.target.value)}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="owner">Owner</MenuItem>
      <MenuItem value="collaborator">Collaborator</MenuItem>
    </Select>
  </FormControl>
);

export default SelectCollaborationStatus;
